<template>
  <BContentBox v-loading="$wait.is(['fetchClientWait','fetchExecutionDaySetting'])">
    <template #content>
      <AccountSetting />
      <ExecutionDaySetting v-if="showExecutionDaySetting" />
    </template>
  </BContentBox>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import AccountSetting from '@/components/organisms/user/setting/account/AccountSetting.vue';
import ExecutionDaySetting from '@/components/organisms/user/setting/account/ExecutionDaySetting.vue';
import { useAvailableFeatureCheck } from '@/composable/available-feature-check';

const { isAvailableSequenceFeature, isAvailableTranscriptionFeature } = useAvailableFeatureCheck();
const showExecutionDaySetting = computed(() => isAvailableSequenceFeature.value || isAvailableTranscriptionFeature.value);
</script>
